
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { Toaster } from 'react-hot-toast';
import Routes from "./Router/Routes/Routes";
import { Helmet } from "react-helmet-async";

function App() {
  return (
    <div className="max-w-6xl mx-auto">
      <RouterProvider router={Routes}></RouterProvider>
      <Toaster></Toaster>
    </div>
  );
}

export default App;
